import { KeyFacet, stringPart } from '../../models/KeyFacet';

export const uploadProgressErrorKeyFacet = new KeyFacet<{
  type: string;
}>('uploadProgress', {
  type: stringPart()
});
